import styled from 'styled-components'

export const OptionalHint = styled.span`
	color: ${({ theme }) => theme.color.input.textHint};
	flex-shrink: 0;
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: 12px;
`
